import { render, staticRenderFns } from "./welcomeComponent.vue?vue&type=template&id=1b11261e"
import script from "./welcomeComponent.vue?vue&type=script&lang=js"
export * from "./welcomeComponent.vue?vue&type=script&lang=js"
import style0 from "./welcomeComponent.vue?vue&type=style&index=0&id=1b11261e&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\new-tis\\FR-TISSOT-IFB-Discovery-SFCC\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b11261e')) {
      api.createRecord('1b11261e', component.options)
    } else {
      api.reload('1b11261e', component.options)
    }
    module.hot.accept("./welcomeComponent.vue?vue&type=template&id=1b11261e", function () {
      api.rerender('1b11261e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "cartridges/int_guidedProductFinder/cartridge/client/default/js/components/welcomeComponent.vue"
export default component.exports